export default "__VITE_ASSET__DyX2troZ__"